import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {MEASUREMENT_TYPES_MAPPINGS_QUERY_KEY} from '../../api/queries/getMeasurementTypesMappings'
import {MeasurementTypesMapping} from '../../types/MeasurementTypesMapping'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export function useMeasurementTypesMappingsQuery(): UseQueryResult<
  MeasurementTypesMapping[],
  unknown
> {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useSettingsQuery(MEASUREMENT_TYPES_MAPPINGS_QUERY_KEY, [plantCode], {
    meta: {
      errorMessage: t('measurementsSettings.queryError', {
        entity: 'Measurement Types Mappings'
      })
    }
  })
}
